<template>
  <div>
    <router-view />

    <alert v-if="isAlert" :data="alertData" @close="closeAlert"></alert>
    <confirm v-if="isConfirm" :data="confirmData" @close="closeConfirm"></confirm>
  </div>
</template>

<script>
import Alert from '@/components/alert/Alert'
import Confirm from "@/components/alert/Confirm";
import {EventBus} from "@/util/EventBus";

export default {
  name: 'App',
  components: {
    Confirm,
    Alert
  },
  data() {
    return {
      isAlert: false,
      isConfirm: false,
      alertData: {},
      confirmData: {},
      loginPage: false
    }
  },
  watch: {
    '$route.name': function(name) {
      this.closeAlert()
      this.closeConfirm()
      this.setLoginClass(name);
    }
  },
  created() {
    const lang = this.$route.query.lang || 'ko'

    this.$i18n.locale = lang
    this.setLoginClass();

    EventBus.$on('openAlert', (data) => {
      this.alertData = data
      this.isAlert = true;
    })

    EventBus.$on('closeAlert', () => {
      this.isAlert = false;
    })

    EventBus.$on('openConfirm', (data) => {
      this.confirmData = data
      this.isConfirm = true;
    })

    EventBus.$on('closeConfirm', () => {
      this.isConfirm = false;
    })
  },
  methods: {
    setLoginClass(name) {
      const currentName = name ? name : this.$route.name;
      this.loginPage = currentName === 'login'
    },
    closeAlert() {
      this.isAlert = false;
    },
    closeConfirm() {
      this.isConfirm = false;
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/layouts/App.vue